import * as React from 'react';
import * as style from './principles.module.scss';
import { principles } from './principles';
import TitleSwiper from './TitleSwiper';
import DescriptionSwiper from './DescriptionSwiper';

export const Principles = () => {
  const [selectedSlideIndex, setSelectedSlideIndex] = React.useState(0);
  const selectSlide = (index) => {
    setSelectedSlideIndex(index);
  };

  return (
    <section className={style.principles}>
      <div className="container">
        <h2 className={style.principles__title}>
          Изучение английского языка — это путь, который вам предстоит пройти. На его длину вы повлиять не можете. А вот
          как вы его пройдёте — решать вам!
        </h2>
        <p className={style.principles__text}>
          В школе вы изучали английский более 1 000 часов, так и не достигнув цели. Зато изучение языка у вас прочно
          ассоциируется с медленным, скучным, сложным, непонятным и безрезультатным процессом.
        </p>
        <p className={style.principles__text}>
          В нашем курсе мы следуем принципам правильного изучения английского. Они таковы:
        </p>
        <div className={style.principles__container}>
          <TitleSwiper selectedSlideIndex={selectedSlideIndex} selectSlide={selectSlide} data={principles} />
          <DescriptionSwiper selectedSlideIndex={selectedSlideIndex} selectSlide={selectSlide} data={principles} />
        </div>
      </div>
    </section>
  );
};
